// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"25a21f64","282":"9ba0c9a5","334":"efefe364","357":"80147bdb","383":"c644f609","456":"6e7e89ae","802":"66fc88f0","864":"ef496487","924":"c3509222"}[chunkId] + ".chunk.css";
};